import { render, staticRenderFns } from "./SenderRecipientTable.vue?vue&type=template&id=679f506d&"
import script from "./SenderRecipientTable.vue?vue&type=script&lang=js&"
export * from "./SenderRecipientTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports